module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recordList"
  }, [(_vm.recordArr.length > 0) ? _c('div', {
    staticClass: "nowNumber"
  }, [_vm._v("当前版本：" + _vm._s(_vm.recordArr[0].recordNum))]) : _vm._e(), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.recordArr,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "fixed": "left",
      "align": "center",
      "width": "60",
      "label": "序号"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n                 " + _vm._s(scope.$index + (_vm.params.no - 1) * _vm.params.size + 1) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "recordNum",
      "align": "center",
      "label": "历史版本"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', {
          staticClass: "ispan",
          on: {
            "click": function($event) {
              _vm.readRecord(scope.row)
            }
          }
        }, [_vm._v(_vm._s(scope.row.recordNum))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operationUser",
      "align": "center",
      "label": "审核人"
    }
  })], 1), _vm._v(" "), (_vm.allPages > 1) ? _c('div', {
    staticClass: "table-footer"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.params.no,
      "page-size": _vm.params.size,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.params.allEls
    },
    on: {
      "current-change": _vm.pageChange
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('recordPop', {
    ref: "recordPop"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-0b2baffa"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/industryInfos/buildingInfos/components/recordList.vue
// module id = 1409
// module chunks = 1